import React from 'react';
// @ts-ignore
import { Heading, HorizontalRule } from 'arag-ui-lib';
import QuestionWithAnswer from '../questionWithAnswer/questionWithAnswer';
import generalStyle from '../../assets/styles/generalStyle.module.scss';

type Props = {
    stepWithQuestionsAndAnswers: {
        name: string;
        questionsWithAnswers: Array<any>;
    };
};
const StepWithQuestionsAndAnswers = (props: Props): JSX.Element => {
    const { stepWithQuestionsAndAnswers } = props;

    return (
        <div className={'row'}>
            <div className={`${generalStyle['heading-inside-tab']} col-sm-12`}>
                <Heading
                    variant="h3"
                    title={stepWithQuestionsAndAnswers.name}
                />
                <div className={'form-horizontal'}>
                    {stepWithQuestionsAndAnswers.questionsWithAnswers.map(
                        questionWithAnswer => (
                            <QuestionWithAnswer
                                key={questionWithAnswer.question.code}
                                questionWithAnswer={questionWithAnswer}
                            />
                        ),
                    )}
                </div>
                <HorizontalRule variant={'pale'} />
            </div>
        </div>
    );
};

export default StepWithQuestionsAndAnswers;
